export default {"src":"/_next/static/media/gray-distance.22b2d572.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};